import { TextField } from "@mui/material";
import { FC } from "react";
import { Control, Controller } from "react-hook-form";

import { CryptorFormData } from "@/pages/cryptor/utils/cryptor.schema";

interface SecondaryColorFieldProps {
  control: Control<CryptorFormData, {}>;
}

const SecondaryColorField: FC<SecondaryColorFieldProps> = ({ control }) => {
  return (
    <Controller
      control={control}
      name="secondaryColor"
      render={({ field, fieldState }) => (
        <TextField
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Couleur secondaire"
          value={field.value}
          onChange={field.onChange}
          margin="normal"
          error={fieldState.invalid}
          fullWidth
        />
      )}
    />
  );
};

export default SecondaryColorField;
